import { Component } from '@angular/core';

@Component({
  selector: 'app-design-gallery',
  templateUrl: './design-gallery.component.html',
  styleUrls: ['./design-gallery.component.css'],
})
export class DesignGalleryComponent {
  columns = ['status', 'vendor', 'model', 'color', 'patient', 'invoice', 'initials'];
  rows = [
    {
      status: 'TO ORDER',
      vendor: '141',
      model: 'ALOHA',
      color: 'NORTHERN LIGHTS',
      patient: 'HERNANDEZ, JASON',
      invoice: 'M94805',
      initials: 'PO',
      hold: false,
    },
    {
      status: 'CALL FOR RX',
      vendor: 'BLAKE KUWAHARA',
      model: 'ALBERS',
      color: 'MIDNIGHT',
      patient: 'OMEGA, PENNA',
      invoice: 'M94790',
      initials: 'SV',
      hold: true,
    },
  ];
  sections = [
    {
      number: '1',
      title: 'Design system',
      rule: 'Start here. Font, field shape, spacing, and these live samples are the contract. Do not invent a second style for a new screen.',
    },
    {
      number: '2',
      title: 'The Stack and To Do Today',
      rule: 'Centered uppercase section bars, shared job columns, alternating rows, and section-specific fields. Sort arrows sit beside the label.',
    },
    {
      number: '3',
      title: 'Inventory and lifetime log',
      rule: 'One inventory row. Aging and location stay subtle. Wholesale and landed cost stay in the log, not the everyday row.',
    },
    {
      number: '4',
      title: 'Borrowing',
      rule: 'Two directions, deposit handling, Sold / Due, and Send Back. Do not duplicate the physical-frame history.',
    },
    {
      number: '5',
      title: 'Stock orders',
      rule: 'Quantity-only or vendor-catalog entry, optional purchase order, then Awaiting Frames and receiving.',
    },
    {
      number: '6',
      title: 'Vendor margin test',
      rule: 'Admin only. Live USD rate, landed cost, and synced multiple, margin, and retail sliders. Saving a rule does not reprice existing stock.',
    },
    {
      number: '7',
      title: 'Lens order',
      rule: 'Lens layout plus invoice identity, lab order number, timestamps, and the M12345-R1 redo sequence.',
    },
    {
      number: '8',
      title: 'Prescription',
      rule: 'Keep every working field, image, comparison, hide, and note. Use the approved field order and eye-by-eye grouping.',
    },
    {
      number: '9',
      title: 'Order header and frame details',
      rule: 'Save & Hold, Save & Checkout, and Save & Next stay, including their pop-ups.',
    },
    {
      number: '10',
      title: 'Awaiting frames and receiving',
      rule: 'Vendor queue, invoice scan, receiving review, and Save Receiving. Working receive controls stay if the prototype omits them.',
    },
    {
      number: '11',
      title: 'Patient portal and scanned orders',
      rule: 'Identity band, notes under patient information, preferences collapsed after the first save, and record accordions that turn teal only when open. Scanned cards stay a fixed width, newest at the upper left. A dark eye opens an AutoOptiq job. A pencil is a legacy scan. The thumbnail opens a viewer that does not move the list. Compare shows the documents side by side. Delete asks the employee to type DELETE.',
    },
  ];
  swatches = [
    { name: 'Teal', token: '--ao-teal', light: true },
    { name: 'Teal dark', token: '--ao-teal-dark', light: false },
    { name: 'Section bar', token: '--ao-section-bar', light: false },
    { name: 'Record head', token: '--ao-section-head', light: true },
    { name: 'Record head text', token: '--ao-on-head', light: false },
    { name: 'Ink', token: '--ao-ink', light: false },
    { name: 'Muted', token: '--ao-muted', light: false },
    { name: 'Line', token: '--ao-line', light: true },
    { name: 'Field', token: '--ao-field', light: true },
    { name: 'Page', token: '--ao-page', light: true },
    { name: 'Panel', token: '--ao-panel', light: true },
    { name: 'Soft', token: '--ao-soft', light: true },
    { name: 'Row alternate', token: '--ao-row-alt', light: true },
    { name: 'Note', token: '--ao-note', light: true },
    { name: 'Note strong', token: '--ao-note-strong', light: true },
    { name: 'Hold', token: '--ao-hold-bg', light: true },
    { name: 'Hold ink', token: '--ao-hold-ink', light: false },
    { name: 'Danger', token: '--ao-danger', light: false },
  ];
}
